import { Link } from "react-router-dom";
import { CalendarHeart } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import Reveal from "./Reveal";
import { OrnamentDivider } from "./BrandGraphics";
import { FAQ } from "../lib/landingContent";

export default function FaqSection() {
  return (
    <section className="bg-[var(--bg)]" data-testid="section-faq">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 md:py-20">
        <Reveal className="text-center mb-8">
          <div className="eyebrow mb-2">FAQ</div>
          <h2 className="font-serif text-3xl md:text-5xl text-[var(--ink)]" data-testid="faq-title">{FAQ.title}</h2>
          <OrnamentDivider className="mt-5" />
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="bg-white rounded-[10px] border-[0.5px] border-[var(--line)] px-5 md:px-8" data-testid="faq-accordion">
            {FAQ.items.map((it, i) => (
              <AccordionItem key={it.q} value={`faq-${i}`} className="border-[var(--line)] last:border-b-0">
                <AccordionTrigger className="text-left font-serif text-lg md:text-xl font-medium text-[var(--ink)] hover:no-underline hover:text-[var(--brand)] py-5" data-testid={`faq-trigger-${i}`}>
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[var(--muted)] leading-relaxed" data-testid={`faq-content-${i}`}>
                  <p>{it.a}</p>
                  {it.list && (
                    <ul className="mt-2 space-y-1 list-disc pl-5">
                      {it.list.map((li) => <li key={li}>{li}</li>)}
                    </ul>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal className="mt-8 text-center">
          <div className="text-sm text-[var(--muted)] mb-3">{FAQ.footnote}</div>
          <Link to={FAQ.cta.to} className="btn btn-primary" data-testid="faq-cta">
            <CalendarHeart className="w-4 h-4" /> {FAQ.cta.label}
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
